import { render } from "./card-poster-template.vue?vue&type=template&id=24efadcc&scoped=true"
import script from "./card-poster-template.vue?vue&type=script&lang=js"
export * from "./card-poster-template.vue?vue&type=script&lang=js"

import "./card-poster-template.vue?vue&type=style&index=0&id=24efadcc&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24efadcc"]])

export default __exports__